import React, { Component } from 'react'
//import { Redirect } from 'react-router-dom'
import { Container, Col, Row } from 'react-bootstrap';
import DayPicker from 'react-day-picker';
import 'react-day-picker/lib/style.css';
// import ListGroup from 'react-bootstrap/ListGroup';
import moment from "moment";
import { FormControl } from 'react-reactive-form';
import './DatePicker.scss';
import ListGroup from 'react-bootstrap/ListGroup';
import 'react-day-picker/lib/style.css';
import { superDeal } from 'assets/images';

export interface DatePickerProps {
    formControl?: FormControl;
    params?: any
}

export interface DatePickerState {
    date: Date;
    selectedDay: any;
}


class DatePicker extends React.Component<DatePickerProps, DatePickerState> {
    daysOfWeek: any[] = this.setSelectedDays((this.props.params || {}).superDealDays);

    constructor(props: any) {
        super(props);
        this.handleDayClick = this.handleDayClick.bind(this);
        this.Navbar = this.Navbar.bind(this);
        this.state = {
            selectedDay: new Date(this.props.formControl ? new Date(this.props.formControl.value) : new Date()),
            date: new Date(),
        };
    }

    componentDidUpdate(prevProps: DatePickerProps, prevState: DatePickerState, snapshot: any) {
        if (prevProps.params != this.props.params) {
            this.daysOfWeek = this.setSelectedDays((this.props.params || {}).superDealDays);
        }
    }

    Navbar() {
        return (
            <></>
        );
    };

    handleDayClick(day: any) {

        // var selected = moment(day.toLocaleDateString()).format("MM/DD/YYYY");
        let today = new Date();
        today.setHours(0, 0, 0, 0)
        if (new Date(day) >= today) {
            localStorage.setItem("movedate", new Date().toISOString());
            if (this.props.formControl) {
                this.props.formControl.setValue(new Date(day).toISOString());
                this.props.formControl.markAsDirty();
                this.props.formControl.markAsTouched();
            }
            this.setState({ selectedDay: new Date(day) })
        }

    };

    setSelectedDays(d: string[] = []) {
        var days: number[] = []
        d.map(a => {
            switch (a.toString()) {
                case "Mondays":
                    days.push(1)
                    break;
                case "Tuesdays":
                    days.push(2)
                    break;
                case "Wednesdays":
                    days.push(3)
                    break;
                case "Thursdays":
                    days.push(4)
                    break;
                case "Fridays":
                    days.push(5)
                    break;
                case "Saturdays":
                    days.push(6)
                    break;
                case "Sundays":
                    days.push(0)
                    break;
            }
        })
        return days
    }

    renderDay(day: any) {
        let date: any = day.getDate()
        const dayNumber: any = day.getDay()
        var daysArray: number[] = this.daysOfWeek;
        //  console.log(daysArray)
        const dateStyle: any = {
            //   position: 'absolute',
            color: 'white',
            //   bottom: 0,
            //   right: 0,
            //   fontSize: 20,
            display: 'flex',
            justifyContent: 'center',
            alignItems: "center",
            position: "relative",
            top: 4,
        };
        // const birthdayStyle: any = { fontSize: '0.8em', textAlign: 'left' };
        const cellStyle: any = {
            height: "2em",
            width: '2em',
            position: 'relative',
            borderRadius: 30,
            backgroundColor: "#219653",
            left: 6,
        };

        return (
            <div style={daysArray.includes(dayNumber) ? cellStyle : {}}>
                <div style={daysArray.includes(dayNumber) ? dateStyle : {}}>{date}</div>
            </div>
        );
    };

    render() {
        return (
            <div>
                <Container fluid className="force-shrink">
                    <Row>
                        {/* <Col sm>
                            <div className="move-header"><h4>{this.state.header.title}</h4>{this.state.header.subtitle ? <p>{this.state.header.subtitle}</p> : null}</div>
                        </Col> */}
                    </Row>
                    <Row className="force-shrunk">

                        <Col>
                        {this.props.params && this.props.params.superDealDays &&
                            <img className="superdeal-img" src={superDeal} alt="img" />
                        }
                            {/* //@ts-ignore */}
                            <DayPicker
                                // modifiers={modifiers}
                                // modifiersStyles={modifiersStyles}
                                fromMonth={this.state.date}
                                numberOfMonths={4}
                                selectedDays={this.state.selectedDay}
                                onDayClick={this.handleDayClick}
                                disabledDays={{ before: this.state.date }}
                                navbarElement={<this.Navbar />}
                                renderDay={(day: any) => this.renderDay(day)}
                            />
                        </Col>

                    </Row>

                </Container>
            </div>
        )

    }
}

export default DatePicker;
